<template>
  <div class="container-fluid  align-items-center" v-loading="loading">
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabChange" v-if="isCorporateEvent">
      <el-tab-pane label="Basic" name="basic">
        <Basic :leadEvent="leadEventDetails || leadEvent" :event_type="event_type" @eventTypeChange="eventTypeChange" @onSave="onBasicSave"/>
      </el-tab-pane>
      <el-tab-pane label="Event Format" name="format">
        <EventFormat :leadEvent="leadEventDetails || leadEvent" @onSave="onEventFormatSave"/>
      </el-tab-pane>
      <el-tab-pane label="Services" name="services">
        <Services :leadEvent="leadEventDetails || leadEvent" @onSave="onServicesSave"/>
      </el-tab-pane>
      <el-tab-pane label="Additional Info" name="additional-info">
        <AdditionalInfo :leadEvent="leadEventDetails || leadEvent" @onSave="onAdditionalInfoSave"/>
      </el-tab-pane>
    </el-tabs>
    <div v-else>
      <Basic :leadEvent="leadEventDetails || leadEvent" @eventTypeChange="eventTypeChange" :event_type="event_type"/>
    </div>
  </div>
</template>
<script>
import {
  Select,
  Option,
  Alert,
  Tabs,
  TabPane
} from "element-ui";
import datePicker from "vue-bootstrap-datetimepicker";
import Basic from '@/views/Widgets/LeadDetails/Components/Edit/Basic';
import EventFormat from '@/views/Widgets/LeadDetails/Components/Edit/EventFormat';
import Services from '@/views/Widgets/LeadDetails/Components/Edit/Services';
import AdditionalInfo from '@/views/Widgets/LeadDetails/Components/Edit/AdditionalInfo';
import leadEventService from "@/services/lead-event.service";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Alert.name]: Alert,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    datePicker,
    Basic,
    EventFormat,
    Services,
    AdditionalInfo,
  },
  props: {
    leadEvent:  {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      activeTab: 'basic',
      event_type: this.leadEvent.event_type,
      leadEventDetails: null,
    };
  },
  computed: {
    isCorporateEvent() {
      return this.event_type === 'corporate';
    }
  },
  created() {
    this.getLeadEventDetails();
  },
  methods: {
    handleTabChange(tab) {
      console.log(tab)
    },
    eventTypeChange(value) {
      this.event_type = value;
    },
    async getLeadEventDetails() {
      this.loading = true;
      let leadEventData = await leadEventService.getLeadEventData(this.leadEvent.id);
      this.loading = false;
      leadEventData = leadEventData.data;
      this.leadEventDetails = leadEventData;
    },
    onBasicSave(result) {
      // Refresh the lead event details to get the updated data
      this.getLeadEventDetails();
      if (this.isCorporateEvent && this.activeTab === 'basic') {
        this.activeTab = 'format';
      }
    },
    onEventFormatSave(result) {
      // Refresh the lead event details to get the updated data
      this.getLeadEventDetails();
      if (this.activeTab === 'format') {
        this.activeTab = 'services';
      }
    },
    onServicesSave(result) {
      // Refresh the lead event details to get the updated data
      this.getLeadEventDetails();
      if (this.activeTab === 'services') {
        this.activeTab = 'additional-info';
      }
    },
    onAdditionalInfoSave(result) {
      // Refresh the lead event details to get the updated data
      this.getLeadEventDetails();
      if (this.activeTab === 'additional-info') {
        this.activeTab = 'basic';
      }
    }
  },
};
</script>